import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
const api = axios.create({ baseURL: `${BASE}/api` });

/** Subir un archivo al object storage y obtener el storage_path persistente. */
export async function uploadFile(file, { category, entityId }) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/files/upload", form, {
    params: { category, entity_id: entityId },
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data; // { id, storage_path, content_type, size, ... }
}

/** Helper: construye URL absoluta para descargar un archivo por su storage_path. */
export function fileUrl(storagePath) {
  if (!storagePath) return "";
  return `${BASE}/api/files/object/${storagePath}`;
}
